package gr.tech.GRAttestation.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.components.widgets.loadingSpinner
import gr.tech.GRAttestation.styles.GenDefaultText
import gr.tech.GRAttestation.styles.OverlayBoxStyle
import gr.tech.GRAttestation.styles.grstyles.DarkGreenHoverButtonStyle
import gr.tech.GRAttestation.styles.grstyles.Theme
import gr.tech.GRAttestation.styles.noBorder
import gr.tech.GRAttestation.util.PDFGenStatus
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

val MessageBoxContainer = CssStyle {
    base {
        Modifier
            .width(min(600.px, 100.percent - 1.cssRem))
            .noBorder()
            .borderRadius(8.px)
            .padding(16.px)
            .margin(topBottom = 24.px)
            .backgroundColor(Colors.White)
            .transition(Transition.all(500.ms))
            .opacity(0)
    }
}

val StatusTextStyle = CssStyle {
    base {
        GenDefaultText
            .fontSize(2.cssRem)
            .color(Theme.DarkGreen.rgb)
            .margin(bottom = 32.px)
    }
}

@Composable
fun OverlayGenerationStatus(
    status: PDFGenStatus,
    onDownload: () -> Unit,
    onReturn: () -> Unit,
) {
    var visible by remember { mutableStateOf(false) }

    // Trigger fade-in once composable is launched
    LaunchedEffect(Unit) {
        delay(100)
        visible = true
    }

    Box(
        modifier = OverlayBoxStyle.toModifier(),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = MessageBoxContainer.toModifier()
                .thenIf(
                    condition = visible,
                    other = Modifier.opacity(1)
                ),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            Img(
                src = "grlogocenter.png",
                alt = "Green Rebates",
                attrs = Modifier.margin(leftRight = autoLength, bottom = 16.px).padding(leftRight = 10.percent).fillMaxWidth().toAttrs()
            )

            // Status Text
            H1(StatusTextStyle.toModifier().toAttrs()) {
                when (status) {
                    PDFGenStatus.GENERATING -> { Text("Uploading Form") }
                    PDFGenStatus.INSTANCE_READY -> {}
                    PDFGenStatus.BLOB_READY -> {}
                    PDFGenStatus.READY_DOWNLOAD -> { Text("Thank you!") }
                    PDFGenStatus.FAILED -> { Text("Something went wrong") }
                }
            }

            // UI Below
            Column(
                modifier = Modifier.fillMaxWidth().height(100.px),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center
            ) {
                when (status) {
                    PDFGenStatus.GENERATING -> {
                        loadingSpinner(
                            iconSize = IconSize.XXL,
                            modifier = Modifier.margin(topBottom = 32.px).scale(1.5).color(Theme.DarkGreen.rgb)
                        )
                    }
                    PDFGenStatus.INSTANCE_READY -> {}
                    PDFGenStatus.BLOB_READY -> {}
                    PDFGenStatus.READY_DOWNLOAD -> {
                        Button(
                            attrs = Modifier.classNames("btn")
                                .width(175.px)
                                .then(GenDefaultText.fontSize(1.5.cssRem))
                                .then(DarkGreenHoverButtonStyle.toModifier())
                                .margin(leftRight = autoLength, bottom = 16.px)
                                .onClick {
                                    it.preventDefault()
                                    onDownload()
                                }
                                .toAttrs()
                        ) {
                            Text("Save Copy")
                        }

                        Button(
                            attrs = Modifier.classNames("btn")
                                .width(175.px)
                                .margin(leftRight = autoLength)
                                .then(GenDefaultText.fontSize(1.5.cssRem))
                                .then(DarkGreenHoverButtonStyle.toModifier())
                                .onClick {
                                    it.preventDefault()
                                    onReturn()
                                }
                                .toAttrs()
                        ) {
                            Text("Return")
                        }
                    }
                    PDFGenStatus.FAILED -> {
                        console.log("Am I not loaded?")

                        P(GenDefaultText.toAttrs()) {
                            Text("Please try again later,")
                        }

                        A(
                            href = "mailto:info@greenrebates.com",
                            attrs = GenDefaultText
                                .margin(leftRight = autoLength, bottom = 16.px)
                                .color(Theme.DarkGreen.rgb).toAttrs()
                        ) {
                            Text("or email sale information to info@greenrebates.com")
                        }

                        Button(
                            attrs = Modifier.classNames("btn")
                                .width(175.px)
                                .margin(leftRight = autoLength)
                                .then(GenDefaultText.fontSize(1.5.cssRem))
                                .then(DarkGreenHoverButtonStyle.toModifier())
                                .onClick {
                                    it.preventDefault()
                                    onReturn()
                                }
                                .toAttrs()
                        ) {
                            Text("Return")
                        }
                    }
                }
            }


        }
    }
}